var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-login"},[_c('div',[_vm._v("微信授权登录")]),_c('pre',[_vm._v("\t\t"+_vm._s(JSON.stringify(_vm.loginResp, null, 2))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }